export default __webpack_public_path__ + "static/media/plus-in-circle.69282864.svg";